import React from 'react';
import ReactDOM from 'react-dom';
import { Sparkles } from 'lucide-react';

const FloatingAIButton = ({ position, onClick, portalContainer }) => {
  if (!position || !position.visible) return null;
  if (!portalContainer) return null;

  // Reason: Use position:absolute relative to editor container
  // Position is already container-relative from ContinuousDocument
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const button = (
    <button
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      data-testid="floating-ai-button"
      className="absolute bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-600 hover:to-blue-700 text-white rounded-md px-2.5 py-1.5 shadow-lg hover:shadow-xl transition-all cursor-pointer"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        pointerEvents: 'auto',
        // z-30: over editor content (<=20) but under Dialog/QuickCommandModal (z-50).
        zIndex: 30,
      }}
      title="Abrir asistente IA"
    >
      <Sparkles className="w-4 h-4" />
    </button>
  );

  return ReactDOM.createPortal(button, portalContainer);
};

export default FloatingAIButton;
